module.exports = __webpack_public_path__ + "staticcomp/img/content_2.6fb67e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/content_2.jpg
// module id = DBfF
// module chunks = 39